module.exports = {
  // 系统名称
  name: "畅收卡",
  // 必填: 后端api地址, 参照下面格式
	apiUrl: "https://api.changshouka.com",
  founUrl:"https://api.changshouka.com/",
  baseUrl:"https://api.changshouka.com",
  // 上传图片url
  uploadUrl:"/api/upload/image",
  addWx:'/pages/my/setup',
  wxapp_id:"10024",
  province:'深圳'
}



// WEBPACK FOOTER //
// ./src/config.js